// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Integration Dashboard Styles */
.integration-dashboard {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.integration-dashboard-header {
  background:
    radial-gradient(circle at 20% 80%, rgba(79, 70, 229, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(20, 184, 166, 0.1) 0%, transparent 50%),
    linear-gradient(135deg, #EA580C, #FDBA74);
  padding: 30px;
  color: white;
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-bottom: 2rem;
}

.integration-dashboard-header h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.875rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.integration-dashboard-header p {
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
}

.integration-dashboard-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.integration-tabs {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.integration-tab {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.2s;
  border-bottom: 2px solid transparent;
}

.integration-tab:hover {
  background-color: #edf2f7;
  color: #2d3748;
}

.integration-tab.active {
  background-color: white;
  color: #2b6cb0;
  border-bottom-color: #2b6cb0;
}

.tab-icon {
  font-size: 1rem;
}

.tab-label {
  font-weight: 500;
}

.integration-content {
  padding: 2rem;
  min-height: 400px;
}

.integration-overview h3 {
  margin: 0 0 1rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
}

.integration-overview p {
  margin: 0 0 2rem 0;
  color: #718096;
  font-size: 1rem;
}

.integration-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.integration-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  transition: all 0.2s;
}

.integration-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}

.integration-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.integration-card h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #2d3748;
}

.integration-card p {
  margin: 0 0 1.5rem 0;
  color: #718096;
  font-size: 0.875rem;
}

.integration-details h3 {
  margin: 0 0 1rem 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
}

.integration-details p {
  margin: 0;
  color: #718096;
  font-size: 1rem;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.btn-primary {
  background-color: #2b6cb0;
  color: white;
  border-color: #2b6cb0;
}

.btn-primary:hover {
  background-color: #2c5282;
  border-color: #2c5282;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .integration-dashboard {
    padding: 1rem;
  }

  .integration-tabs {
    flex-direction: column;
  }

  .integration-tab {
    justify-content: center;
  }

  .integration-content {
    padding: 1rem;
  }

  .integration-cards {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/integrations/IntegrationDashboard.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;;;6CAG2C;EAC3C,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iFAAiF;EACjF,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iFAAiF;EACjF,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Integration Dashboard Styles */\n.integration-dashboard {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.integration-dashboard-header {\n  background:\n    radial-gradient(circle at 20% 80%, rgba(79, 70, 229, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(20, 184, 166, 0.1) 0%, transparent 50%),\n    linear-gradient(135deg, #EA580C, #FDBA74);\n  padding: 30px;\n  color: white;\n  position: relative;\n  overflow: hidden;\n  border-radius: 16px;\n  margin-bottom: 2rem;\n}\n\n.integration-dashboard-header h2 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.integration-dashboard-header p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1rem;\n}\n\n.integration-dashboard-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.integration-tabs {\n  display: flex;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.integration-tab {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 1rem 1.5rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #4a5568;\n  transition: all 0.2s;\n  border-bottom: 2px solid transparent;\n}\n\n.integration-tab:hover {\n  background-color: #edf2f7;\n  color: #2d3748;\n}\n\n.integration-tab.active {\n  background-color: white;\n  color: #2b6cb0;\n  border-bottom-color: #2b6cb0;\n}\n\n.tab-icon {\n  font-size: 1rem;\n}\n\n.tab-label {\n  font-weight: 500;\n}\n\n.integration-content {\n  padding: 2rem;\n  min-height: 400px;\n}\n\n.integration-overview h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.integration-overview p {\n  margin: 0 0 2rem 0;\n  color: #718096;\n  font-size: 1rem;\n}\n\n.integration-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.integration-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  text-align: center;\n  transition: all 0.2s;\n}\n\n.integration-card:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  transform: translateY(-1px);\n}\n\n.integration-icon {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n}\n\n.integration-card h4 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.integration-card p {\n  margin: 0 0 1.5rem 0;\n  color: #718096;\n  font-size: 0.875rem;\n}\n\n.integration-details h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.integration-details p {\n  margin: 0;\n  color: #718096;\n  font-size: 1rem;\n}\n\n.btn {\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n}\n\n.btn-primary {\n  background-color: #2b6cb0;\n  color: white;\n  border-color: #2b6cb0;\n}\n\n.btn-primary:hover {\n  background-color: #2c5282;\n  border-color: #2c5282;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .integration-dashboard {\n    padding: 1rem;\n  }\n\n  .integration-tabs {\n    flex-direction: column;\n  }\n\n  .integration-tab {\n    justify-content: center;\n  }\n\n  .integration-content {\n    padding: 1rem;\n  }\n\n  .integration-cards {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
